import { useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { Button, Progress } from "@heroui/react"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import NextUITable, { COLUMN_ALIGN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { calculateTotal } from "../../Utility/utility"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetail, setDetailParam, setNewEntryMode} from "../../state/authSlice"

const UserMaster = () => {
    let { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    let { token, user } = useSelector((state) => state.auth)
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [itemToDelete, setItemToDelete] = useState("")
    // let [data, setData] = useState([])

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)
    }, [])

    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "LoginName",
        "Name",
        "ContactNo",
    ]
    const exportColumns = [
        {
            name: "Login ID",
            uid: "LoginName",
        },
        {
            name: "Name",
            uid: "Name",
        },
        {
            name: "Contact No",
            uid: "ContactNo",
        },


    ]
    const onSuccessDelete = (data) => {
        if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Account can't be delete as it locked", {
                    position: "top-center",
                    "className": "toast-error",
                })
            }
            else {
                setItemToDelete("")
                funLoadData();
                toast.success("Account Deleted",
                    {
                        position: "top-center",
                        "className": "toast-error",
                    })

            }


        }
    }

    const { mutate: FndeleteAccount } = usePost(
        {
            url: apiRoute.user.deleteEntry,
            query: "delete-note",
            onSuccessTasks: onSuccessDelete
        }
    )

    const { isPending, isError, data = [], mutate: filterData } = usePost({
        url: apiRoute.user.fetch,
        queryKey: "fetchuserMaster"

    })

    const funLoadData = () => {
        filterData({
            data: {
                client_code: user.clientCode

            }
        })
    }

    // const handleDataChange = ({ data, isFilter }) => {
    //     if (isFilter)
    //         setData(data)
    //     else
    //         setData(AccountData)
    // }

    useEffect(() => {
        
        funLoadData();
    }, [])

    // useEffect(() => {
    //     setData(AccountData)
    // }, [AccountData])




    let downloadDataFooter = {
        LoginName: "",
        Name: "",
        ContactNo: "",
    }

    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }

    const handleConfirmBox = (data) => {
        if (data) {
            FndeleteAccount({
                data: {
                    login_name: itemToDelete.LoginName,
                    comp_code: compCode.join(","),
                    user_id:itemToDelete.UserID,
                    client_code:itemToDelete.Client_Code
                }
            })
        }
        else {
            setItemToDelete("")
        }

    }

    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Login ID",
            uid: "LoginName",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Name",
            uid: "Name",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Conatc No",
            uid: "ContactNo",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        

    ]

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                
                dispatch(setDetailParam(row))
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.user.createUserEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete(row)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]

    const handleAddNew = () => {
        navigate(linksUrl.user.createUserEntry);
        dispatch(resetDetail())
    }

    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName="Users" info={[]} breadcrumbs={[ "User Master"]} >



                <div className="flex gap-2 justify-end">
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}
                    >
                        Add New

                    </Button>

                    {/* <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleImport}
                    >
                        Import Account
                    </Button> */}
                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="user-master-List"
                    showAdvanceFilter={false}
                    id="LoginName"
                ></NextUITable>
            </MainContainer >
        </div >
    )
}
export default UserMaster